export default "__VITE_ASSET__8cx05uqU__"